//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { SearchOutlined } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Divider from '@material-ui/core/Divider';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { setClassNameInDefns } from '../../common/definitionHelper';
// import { saveSearch } from '../../common/services/jobCenterServices';
import { AppContext } from '../../common/contexts';
import { BASE_URL } from '../../common/constants';
import { PATH_JOB_CENTER } from '../../system/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdAutocompleteLite from '../../common/elemental/AfitdAutocompleteLite';
import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
import clsx from 'clsx';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            cursor: 'pointer',
            display: 'flex',
            borderRadius: '4px',
            background: 'white',
            alignItems: 'center',
            padding: '8px',
            border: '2px solid #F0F2F6',
            [theme.breakpoints.down('sm')]: { flexDirection: 'column', alignItems: 'normal', position: 'relative', padding: '8px 0px 8px 0px' },
        },
        searchInput: {
            display: 'flex',
            borderRadius: '4px',
            background: 'white',
            alignItems: 'center',
            padding: '8px',
            border: '2px solid #F0F2F6',
            [theme.breakpoints.down('sm')]: { flexDirection: 'column', alignItems: 'normal', position: 'relative', padding: '8px 0px 8px 0px' },
        },
        searchInputFocus: {
            background: '#fff',
            border: '2px solid #1D8A8B',
        },
        forwardIconContainer: {
            [theme.breakpoints.down('sm')]: { position: 'absolute', top: 20, right: 10 },
        },
        iconContainer: {
            cursor: 'pointer',
            // width: 'auto',
            // too check again
            border: 'none',
            marginRight: '5px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(17, 30, 20, 1)',
            color: '#fff',
            width: 45,
            height: 45,
            borderRadius: 5,
            [theme.breakpoints.down('sm')]: { width: 54, height: 54 },
        },
        searchIconContainer: {
            // cursor: 'pointer',
            width: 'auto',
            marginRight: '5px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // color: 'rgba(17, 30, 20, 0.4)',
            marginLeft: '10px',
            [theme.breakpoints.down('sm')]: { justifyContent: 'flex-start', position: 'absolute', top: 10 },
        },
        searchIcon: { fontSize: 28 },
        borderMiddle: { color: '#D5D7DD' },
        locationIconContainer: {
            // cursor: 'pointer',
            width: 'auto',
            marginRight: '5px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // color: 'rgba(17, 30, 20, 0.4)',
            marginLeft: '10px',
            [theme.breakpoints.down('sm')]: { justifyContent: 'flex-start', position: 'absolute', top: 58 },
        },
        icon: {
            color: '#9B9E9C',
        },
        iconActive: {
            color: '#1D8A8B',
        },
        inputSide: {
            flex: 1,
            borderRight: '1px solid #D5D7DD',

            '& fieldset': {
                display: 'none',
            },
            [theme.breakpoints.down('sm')]: { paddingLeft: 40, margin: '4px 0 12px 0' },
        },
        inputSideAddress: {
            flex: 1,
            '& fieldset': {
                border: 'none',
            },
            [theme.breakpoints.down('sm')]: { paddingLeft: 40, margin: '12px 0 4px 0' },
        },
        dropDown: {
            fontWeight: 600,
            '& .MuiAutocomplete-popupIndicator': {
                display: 'none',
            },
            '& .MuiAutocomplete-input': {
                fontSize: '16px',
                fontWeight: '600',
                color: '#1D8A8B',
            },
            '& .MuiAutocomplete-input::placeholder': {
                // fontWeight: '400',
                fontSize: 16,
                color: 'black',
            },

            '& .MuiAutocomplete-inputRoot': {
                paddingLeft: 10,
                borderRadius: '0px',
            },
            '& .MuiInputBase-root': {
                padding: '0 !important',
            },
            '& .MuiInputBase-root input': {
                maxWidth: '80%',
            },
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        searchFocus,
        // setSearchFocus,
        addressFocus,
        // setAddressFocus,
        // props,
        // appContext,
        handleClickSearchInput,
    } = params;

    const {
        // searchInput: searchInputCls,
        //  searchInputFocus: searchFocusCls,
        dropDown: dropDownCls,
        icon: IconCls,
        iconActive: iconActiveCls,
    } = classes;
    // const { query } = props;

    // const { currentUser, userId } = appContext;

    // // Fix search when integrating ElasticSearch??
    // console.log('TODO: Fix search when integrating ElasticSearch', { query, currentUser, userId });

    const defns = {
        icon: {
            className: clsx(IconCls, { [iconActiveCls]: searchFocus || addressFocus }),
        },
        root: {
            // className: clsx(searchInputCls, { [searchFocusCls]: searchFocus || addressFocus }),
            onClick: handleClickSearchInput,
        },
        // leftInput: {
        //     // value: query.jobTitle,
        //     // onChange: (e, val) => setQuery(prevQuery => getNewJobCenterQuery({ prevQuery, newQuery: { xxxxxxxxxx } }));
        //     // onChange: (e, val) => setQuery(prev => ({ ...prev, jobTitle: val })),
        //     disabled: true,
        //     onBlur: () => setSearchFocus(false),
        //     onFocus: () => setSearchFocus(true),
        //     placeholder: 'Search Jobs Titles',
        //     className: dropDownCls,
        //     options: Options.map(el => el.label),
        // },
        // rightInput: {
        //     // value: query.location,
        //     // onChange: (e, val) => setQuery(prevQuery => getNewJobCenterQuery({ prevQuery, newQuery: { xxxxxxxxxx } }));
        //     // onChange: (e, val) => setQuery(prev => ({ ...prev, location: val })),
        //     disabled: true,
        //     onBlur: () => setAddressFocus(false),
        //     onFocus: () => setAddressFocus(true),
        //     placeholder: 'City or State / Province ',
        //     className: dropDownCls,
        //     options: Address.map(el => el.label),
        // },
        leftInput: {
            value: 'Search Job Titles',
            className: dropDownCls,
            clsGrayColor: true,
        },
        rightInput: {
            value: 'City or State / Province ',
            className: dropDownCls,
            clsGrayColor: true,
        },
    };

    // inject classes
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
// const Options = [
//     { value: 'Product', label: 'Product' },
//     { value: 'Production', label: 'Production' },
//     { value: 'Product Manger', label: 'Product Manger' },
//     { value: 'Product Analyst', label: 'Product Analyst' },
//     { value: 'Product Marketing', label: 'Product Marketing' },
//     { value: 'Product Designer', label: 'Product Designer' },
// ];

// const Address = [
//     { value: 'London, KY', label: 'London, KY' },
//     { value: 'London, OH', label: 'London, OH' },
//     { value: 'London, NH', label: 'London, NH' },
//     { value: 'London, WV', label: 'London, WV' },
//     { value: 'London, AR', label: 'London, AR' },
// ];

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const HomeSearchInput = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    const appContext = useContext(AppContext);
    const theme = useTheme();
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));
    const history = useHistory();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [searchFocus, setSearchFocus] = useState(false);
    const [addressFocus, setAddressFocus] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleClickSearchInput = () => {
        history.push(`${BASE_URL}${PATH_JOB_CENTER}`);
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        searchFocus,
        setSearchFocus,
        addressFocus,
        setAddressFocus,
        appContext,
        handleClickSearchInput,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.searchIconContainer}>
                <SearchOutlined {...defns.searchIcon} />
            </div>
            <div {...defns.inputSide}>
                {/* <AfitdAutocompleteLite {...defns.leftInput} /> */}
                <AfitdTypography {...defns.leftInput} />
            </div>
            {smMatches ? (
                <div {...defns.borderMiddle}>
                    <Divider />
                </div>
            ) : null}

            <div {...defns.locationIconContainer}>
                <LocationOnIcon {...defns.searchIcon} />
            </div>
            <div {...defns.inputSideAddress}>
                {/* <AfitdAutocompleteLite {...defns.rightInput} /> */}
                <AfitdTypography {...defns.rightInput} />
            </div>
            <div {...defns.forwardIconContainer}>
                <button {...defns.iconContainer}>
                    <ArrowForwardIcon />
                </button>
            </div>
        </div>
    );
};

export default HomeSearchInput;
